import { reenrolmentApi } from './clients';

/**
 * Re-enrolling a child a family had marked as leaving.
 *
 * The server decides whether this is offered at all — an administrator has to have turned it on,
 * and a campus holding credit is always sent to the accounts team instead. The screen asks rather
 * than working it out, so the two cannot disagree.
 */

export const fetchWithdrawnChildren = async (parentID) => {
    const { data } = await reenrolmentApi.post('/withdrawn-children', { parentID });
    return data;
};

export const reEnrolWithdrawnChildren = async (parentID, studCodes) => {
    const { data } = await reenrolmentApi.post('/re-enrol-withdrawn-child', {
        parentID,
        stud_codes: studCodes,
    });
    return data;
};
